import { MAX_FREE_PROGRAMS } from "./getRemainingFreePrograms";

export const PROGRAM_GUEST_SIGNUP_DESCRIPTION = `Sign up now to create ${MAX_FREE_PROGRAMS} free program${MAX_FREE_PROGRAMS === 1 ? "" : "s"} on us!`;
